var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "course-page" }, [
    _c(
      "div",
      { staticClass: "banner" },
      [_c("Nav", { staticClass: "nav", attrs: { num: 1 } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "mainContent",
      },
      [
        _c("div", { staticClass: "course-header" }, [
          _c(
            "div",
            { staticClass: "breadcrumb" },
            [
              _c(
                "el-button",
                {
                  staticClass: "back-btn",
                  attrs: { icon: "el-icon-back", size: "small" },
                  on: { click: _vm.goBack },
                },
                [_vm._v("返回资源库")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "path" }, [_vm._v("专业教学资源库 /")]),
              _vm._v(" "),
              _c("span", { staticClass: "library-name" }, [
                _vm._v(_vm._s(_vm.library.name || "资源库详情")),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.library.id
            ? _c("div", { staticClass: "library-body" }, [
                _c("div", { staticClass: "library-image" }, [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.fileUrl(_vm.library.previewPic) ||
                        _vm.$store.getters.noImg,
                      alt: _vm.library.name,
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "library-info" }, [
                  _c("div", { staticClass: "library-title" }, [
                    _vm._v(_vm._s(_vm.library.name)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "library-meta" }, [
                    _vm._v(_vm._s(_vm.library.emceeCompanyname || "---")),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "library-tags" }, [
                    _c("span", [_vm._v(_vm._s(_vm.library.industry || "---"))]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.library.industryDetailName ||
                            _vm.library.industryDetail ||
                            "---"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.library.majorId || "---"))]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.library.majorLevel || "---")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "library-count" }, [
                    _vm._v(
                      "已上架课程 " +
                        _vm._s(_vm.library.courseCount || 0) +
                        " 门"
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "course-toolbar" }, [
          _c(
            "div",
            { staticClass: "search-box" },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入课程名称", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search($event)
                  },
                },
                model: {
                  value: _vm.courseName,
                  callback: function ($$v) {
                    _vm.courseName = $$v
                  },
                  expression: "courseName",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.search } },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.courseList.length > 0
          ? _c(
              "div",
              { staticClass: "course-list" },
              _vm._l(_vm.courseList, function (item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "course-item" },
                  [
                    _c("CourseResource", {
                      attrs: { type: 1, item: item, "click-mode": "course" },
                    }),
                  ],
                  1
                )
              }),
              0
            )
          : !_vm.loading
          ? _c("div", { staticClass: "empty" }, [
              _c("img", {
                attrs: { src: _vm.$store.getters.noData, alt: "暂无数据" },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.total > 0
          ? _c(
              "div",
              { staticClass: "pagination-box" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "current-page": _vm.query.pageNum,
                    "page-size": _vm.query.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    "pager-count": 5,
                    total: _vm.total,
                  },
                  on: {
                    "current-change": _vm.handleCurrentChange,
                    "size-change": _vm.handleSizeChange,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }